import React, { useState } from "react";
import ReactDOM from "react-dom";
import useRootClose from "react-overlays/useRootClose";
import { Popper } from "react-popper";
import PropTypes from "prop-types";
import styles from "./Menu.module.scss";
import { applyRef } from "../../Helpers/applyRef";

const Menu = ({
  open,
  elementToClick,
  children,
  clickPropagationStopped,
  attachElement,
  onClose,
  keepOpenAfterClick
}: {
  open: any;
  elementToClick: any;
  children: any;
  clickPropagationStopped: boolean;
  attachElement: any;
  onClose: any;
  keepOpenAfterClick: any;
}) => {
  const [toggle, setToggle] = useState(false);
  const [containerRef, setContainerRef] = useState<HTMLElement | null>(null);
  const [popperRef, setPopperRef] = useState<HTMLElement | null>(null);

  useRootClose(
    keepOpenAfterClick ? popperRef : attachElement || containerRef,
    () => {
      setToggle(false);
      if (onClose) {
        onClose();
      }
    },
    { disabled: open != null ? !open : !toggle }
  );

  return (
    <div className={styles.container} ref={setContainerRef}>
      {elementToClick && (
        <div
          className={styles.element}
          onClick={event => {
            if (clickPropagationStopped) {
              event.stopPropagation();
              event.preventDefault();
            }

            setToggle(true);
          }}
        >
          {elementToClick}
        </div>
      )}
      {(open || toggle) &&
        ReactDOM.createPortal(
          <Popper
            referenceElement={attachElement || containerRef}
            modifiers={[
              {
                name: "preventOverflow",
                options: {
                  // 20px padding to prevent the menu from sticking to the edge
                  // or the viewport
                  padding: 20
                }
              }
            ]}
          >
            {({ ref, style, arrowProps }) => (
              <div
                ref={node => {
                  applyRef(ref, node);
                  setPopperRef(node);
                }}
                style={{ ...style, zIndex: 1000 }}
              >
                <span ref={arrowProps.ref} className={styles.arrow} style={arrowProps.style} />
                <div
                  className={styles.menu}
                  onClick={event => {
                    event.stopPropagation();
                    event.preventDefault();
                  }}
                >
                  {children}
                </div>
              </div>
            )}
          </Popper>,
          document.body
        )}
    </div>
  );
};

Menu.propTypes = {
  elementToClick: PropTypes.node,
  children: PropTypes.node.isRequired,
  clickPropagationStopped: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  attachElement: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  keepOpenAfterClick: PropTypes.bool
};

Menu.defaultProps = {
  elementToClick: null,
  clickPropagationStopped: false,
  attachElement: null,
  open: null,
  onClose: null,
  keepOpenAfterClick: false
};

export default Menu;
